const bounce = {

  flash_history: true,

  appendMode: function(frame, node, appending = true) {
    frame.append(node);
  },


  retrieve: function(e) {
    bounce.lock = true;

    var current   = $(e);
    var appending = current.hasClass('bounce-next');
    var url       = current.attr('href');
    var next      = $('.bounce-control.bounce-next');
    var prev      = $('.bounce-control.bounce-prev');

    if(!url) {
      current.hide();
      bounce.lock = false;
      return;
    }

    current.find('.default').hide();
    current.find('.loading').show();

    bounce.xhr = $.ajax({
      url: url,
      type: 'GET',
      headers: {
        Accept: 'application/json'
      },

      data: {
        source: appending ? 'next' : 'prev'
      }
    })
    .done(function(data) {
      var type      = $('.bounce-frame').prop("tagName").toLowerCase();
      var newframe  = $(`<${type}>`).addClass('bounce-frame').attr('data-location', data.current);

      var container = appending ? $('.bounce-frame:last') : $('.bounce-frame:first');

      Object.keys(data.render).forEach(function(i) {
        bounce.appendMode(newframe, data.render[i], appending);
      });

      if(appending)
        container.after(newframe);
      else
        container.before(newframe);

      var scrolltop = newframe.outerHeight();


      if(appending) {
        next.attr('href', data.next ? data.next : null).toggle(!!data.next);
      }
      else{
        prev.attr('href', data.next ? data.next : null).toggle(!!next);
        $('html, body').animate({
          scrollTop: scrolltop ,
        }, 0);
      }

      bounce.lock = false;
      $(document).trigger('scroll');
      if(bounce.onSuccess) bounce.onSuccess(current, data);

    })
    .always(function() {
      current.find('.default').show();
      current.find('.loading').hide();
    });

  },

  isHiddingByTop: function(rect) {
    return rect.y + rect.height <= 0;

  },

  isHiddingByBottom: function(rect) {
    return rect.y >= window.innerHeight;
  },

  onLeaveCurrentNode: function(e) {
    var frame = $('.bounce-frame.current');
    if(!frame.length) return;

    var rect = frame[0].getBoundingClientRect();

    if(bounce.isHiddingByTop(rect))
      var currentframe = frame.next();
    else if(bounce.isHiddingByBottom(rect))
      var currentframe = frame.prev();

    if(currentframe){
      frame.removeClass('current');
      currentframe.addClass('current');

      
    }

    if(currentframe && bounce.flash_history) {


      history.replaceState(null, '', currentframe.data('location'));

    }

  },

  onReachPaginator: function(e) {
    for (var i = 0; i < bounce.control.length; i++) {
      var rect = bounce.control[i].getBoundingClientRect();
      if(rect.y - bounce.rect_offset <= window.innerHeight - $('.top-header').height() && rect.y + bounce.rect_offset > 0 ){
        $(bounce.control[i]).trigger('click');
      }
    }
  },
  
  init: function() {
    bounce.control = $('.bounce-control');

    $(document).scroll(function(e) {
      bounce.onReachPaginator(e);
      bounce.onLeaveCurrentNode(e);
    });


    $('.bounce-control').click(function(e) {
      e.preventDefault();
      if(bounce.lock) return;
      bounce.retrieve(this);
    });

    bounce.rect_offset = $(window).height() * .7;

  },

}

bounce.init();

module.exports = {

  onSuccess: function(handler) {
    bounce.onSuccess = handler;
  },

  setFlashHistoryEnabled(isenabled) {
    bounce.flash_history = isenabled;
  },

  setNextUrl(url) {
    $('.bounce-next').attr('href', url);
  },

  appendMode(handler) {
    bounce.appendMode = handler;
  }

}